const determineImageCrop = (contentType) => {
  const portraitContentTypes = ['Whitepaper', 'Company Report', 'Interview']
  const widescreenContentTypes = ['Video']
  if (portraitContentTypes.includes(contentType)) {
    return 'portrait'
  }
  if (widescreenContentTypes.includes(contentType)) {
    return 'widescreen'
  }

  return 'landscape'
}

export default determineImageCrop
